import logoHorizontal from '@/assets/logos/logo-horizontal.png';
import logoStacked from '@/assets/logos/logo-reduzido.png';
import logoIcon from '@/assets/logos/logo-icon.png';
import { appConfig } from '@/config';
import { cn } from '@/utils/cn';

const sizeClasses = {
  sm: 'h-7',
  md: 'h-10',
  lg: 'h-36',
};

const variantSrc = {
  horizontal: logoHorizontal,
  stacked: logoStacked,
  icon: logoIcon,
};

export function BrandLogo({
  className,
  variant = 'horizontal',
  size = 'md',
  showTagline = false,
}) {
  const src = variantSrc[variant] ?? logoHorizontal;
  // Tagline já vem na arte horizontal; stacked/icon podem exibir o texto do config.
  const showTaglineText = showTagline && variant !== 'horizontal';

  return (
    <div className={cn('flex flex-col items-start gap-1.5', className)}>
      <img
        src={src}
        alt={appConfig.appName}
        className={cn('w-auto max-w-full object-contain', sizeClasses[size])}
      />
      {showTaglineText ? (
        <p className="max-w-[16rem] text-[0.7rem] font-medium leading-snug tracking-wide text-[var(--muted-foreground)]">
          {appConfig.tagline}
        </p>
      ) : null}
    </div>
  );
}
